import * as api from "../API/index";
import {
  certificateIssuanceReport,
  attendanceReport,
  certificatePendingReport,
  courseEnrollmentReport,
  instructorDailyAttendanceReport,
  instructorDashboardSummary,
  instructorAssessmentReport,
  instructorAssessmentReportDetails,
} from "constants/report";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getCertificateIssuanceReport = async (
  dispatch,
  filters,
  pageNum,
) => {
  try {
    const res = await api.get_certificate_issuance_report(filters, pageNum);

    dispatch({
      type: certificateIssuanceReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: certificateIssuanceReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getAttendanceReport = async (dispatch, filters, pageNum) => {
  try {
    const res = await api.get_attendance_report(filters, pageNum);

    dispatch({
      type: attendanceReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: attendanceReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getCertificatePendingReport = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_certificate_pending_report(pageNum, filters);

    dispatch({
      type: certificatePendingReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: certificatePendingReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getCourseEnrollmentReport = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_course_enrollment_report(pageNum, filters);

    dispatch({
      type: courseEnrollmentReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: courseEnrollmentReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getInstructorDailyAttendanceReport = async (
  dispatch,
  filters,
  pageNum,
) => {
  try {
    const res = await api.get_instructor_daily_attendance_report(
      filters,
      pageNum,
    );

    dispatch({
      type: instructorDailyAttendanceReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: instructorDailyAttendanceReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getInstructorDashboardSummary = async (
  dispatch,
  pageNum = 1,
) => {
  try {
    const res = await api.get_instructor_dashboard_summary(
      pageNum,
    );

    dispatch({
      type: instructorDashboardSummary,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: instructorDashboardSummary,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getInstructorAssessmentReport = async (
  dispatch,
  filters,
  pageNum,
) => {
  try {
    const res = await api.get_instructor_assessment_report(filters, pageNum);

    dispatch({
      type: instructorAssessmentReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: instructorAssessmentReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const getInstructorAssessmentReportDetails = async (
  dispatch,
  assessmentId,
  batchId,
  filters,
  pageNum,
) => {
  try {
    const res = await api.get_instructor_assessment_report_details(
      assessmentId,
      batchId,
      filters,
      pageNum,
    );

    dispatch({
      type: instructorAssessmentReportDetails,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: instructorAssessmentReportDetails,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};
